<template>
    <div class="bromierung-benzol">
        <ul>
            <li>elektrophile Substitution</li>
            <li>mit Katalysator</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'bromierung-benzol',
};
</script>
